export const leaseOptionObj = {
    asset: null,
    lessee: null,
    lessor: null,
    owner: null,
    operator: null,
    lease_type: null,
    lease_duration_type: null,
    lessee_id: "",
    asset_id: "",
    asset_slug: "",
    asset_type: "",
    same_operator_lessee: "",
    operator_id: "",
    contractual_start_date: "",
    contractual_end_date: "",
    mr_account_number: "",
    rental_account_number: "",
    csn: "",
    executed_by: "",
    lessor_id: "",
    assigned_code: "",
    is_reserve_rate: 0
}

export const assetTypeMap = {
    1: "aircraft",
    2: "engine",
    3: "apu",
    4: "landing_gear",
    5: "propeller",
    6: "fan",
    7: "hpc",
    8: "hpt",
    9: "lpt",
    10: "component"
};